 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons"  :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'doctorAdd'" @click="addBloc">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">集团简称：</span>
                <el-input v-model="short_name" placeholder="集团简称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">集团全称：</span>
                <el-input v-model="bloc_name" placeholder="集团全称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    v-model="status" placeholder="请选择状态"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">集团分类：</span>
                <el-select
                    clearable
                    v-model="catalog_id" placeholder="请选择集团分类"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allCatalog"
                            :key="item.id"
                            :label="item.catalog_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="short_name" label="集团简称" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="bloc_name" label="集团全称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="catalog_name" label="集团分类" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="150" prop="user_number" label="特属服务对象数量" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240"
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteData(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopBloc(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopBloc(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'doctorEdit'" @click="gerAllUser(scope.row)"
                           type="text" size="mini">特属服务对象
                </el-button>
                <el-button :id="'doctorEdit'" @click="addUser(scope.row)"
                           type="text" size="mini">添加特属服务对象
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
            if (this.$route.params.catalog_id) {
                this.catalog_id = this.$route.params.catalog_id;
            }
        },
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                bloc_name: '',
                catalog_id: '',
                status: '',
                short_name: '',
                allCatalog: [],
                is_submit: false,
                button_position: 'absolute',
            };
        },
        mounted() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            // 获取特属服务对象列表
            this.getList();
            this.getAllCatalog();
            localStorage.setItem('prev_page', 'bloc_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'blocListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        bloc_name: this.bloc_name,
                        catalog_id: this.catalog_id,
                        short_name: this.short_name,
                        status: this.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            getAllCatalog() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllBlocCatalog',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCatalog = res.data.data;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = false;
                this.bloc_name = "";
                this.catalog_id = "";
                this.short_name = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "blocEdit", params: {
                        id: data.id,
                        bloc_name: data.bloc_name,
                        short_name: data.short_name,
                        sort: data.sort,
                        catalog_id: data.catalog_id,
                        principal: data.principal,
                        office_phone: data.office_phone,
                        address: data.address,
                        remark: data.remark,
                        status: parseInt(data.status_number),
                    }
                });
            },

            // 新增公司
            addBloc() {
                this.$router.push({name: "blocAdd", params: {}});
            },

            deleteData(data) {
                this.$confirm('确定删除该集团吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'deleteBloc',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 启用停用公司
            startStopBloc(data, status) {
                if (status == '1') {
                    var message = '确定启用该集团吗？';
                }
                if (status == '2') {
                    var message = '确定停用该集团吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'startStopBloc',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 跳转到下属部门
            gerAllUser(data) {
                this.$router.push({
                    name: "userList", params: {
                        bloc_id: data.id
                    }
                });
            },

            // 跳转到添加部门
            addUser(data) {
                if (data.status_number == '2') {
                    this.$message.error('请先启用该数据！');
                    return;
                }
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/user/UserAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "userAdd", params: {
                        bloc_id: data.id
                    }
                });
                return;
            },

            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'exportBloc',
                    params: {
                        bloc_name: this.bloc_name,
                        catalog_id: this.catalog_id,
                        short_name: this.short_name,
                        status: this.status,
                    },
                };
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "集团简称", key: "short_name"},
                    {title: "集团全称", key: "bloc_name"},
                    {title: "集团分类", key: "catalog_name"},
                    {title: "特属服务对象数量", key: "user_number"},
                    {title: "更新时间", key: "update_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            id: res_data.data[i].id,
                            short_name: res_data.data[i].short_name,
                            bloc_name: res_data.data[i].bloc_name,
                            catalog_name: res_data.data[i].catalog_name,
                            user_number: res_data.data[i].user_number,
                            update_date: res_data.data[i].update_date,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出集团");
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
